export function sortArrayByTitle(x, y) {
  return x.title.localeCompare(y.title);
}

export function sortArrayByName(x, y) {
  return x.name.localeCompare(y.name);
}
